// extracted by mini-css-extract-plugin
export default {"wrapper":"text-box_wrapper__xkmZP"};